import { InstallationRefusal } from '@core/helpers/installation-refusal.helper';

export interface SettingsRefusal {
  messageKey: string;
  // What the dialog was opened on has changed underneath it, so the card must read it again.
  stale: boolean;
}

const ERRORS = 'installations.attributes.errors.';
const EDITOR_ERRORS = 'installations.editor.errors.';

// Explains a refused settings write in the dialog that sent it. Every other status, and a 422 that
// the dialog has no better word for, means the request itself was wrong, which the user cannot fix,
// so it reads like any other failure to save.
export function settingsRefusal(
  refusal: InstallationRefusal,
  unprocessableKey = `${EDITOR_ERRORS}notSaved`,
): SettingsRefusal {
  const { status, reason } = refusal;
  if (status === 400 && reason === 'phase_count_fixed_by_source') {
    return { messageKey: `${ERRORS}phaseCountFixed`, stale: true };
  }
  if (status === 409 && reason === 'installation_not_active') {
    return { messageKey: `${EDITOR_ERRORS}installationNotActive`, stale: true };
  }
  if (status === 401 || status === 403) {
    return { messageKey: `${ERRORS}notAllowed`, stale: false };
  }
  if (status === 404) {
    return { messageKey: `${ERRORS}notFound`, stale: true };
  }
  if (status === 422) {
    return { messageKey: unprocessableKey, stale: false };
  }
  return { messageKey: `${EDITOR_ERRORS}notSaved`, stale: false };
}
